<template>
  <div
    v-if="!searchByZipCode"
    class="grid-x list-wrapper"
  >
    <div
      v-for="(
        {
          name,
          distance,
          address,
          storeNumber,
          today,
          localStorageModel,
          tomorrow,
          bossAvailabilityMessage,
          locationNumber,
          pickupItemInfo,
          pickupRelativeDay,
          bopsAvailability,
          bossAvailability,
          productId,
        },
        index
      ) in stores"
      :key="index"
      class="cell small-12 padding-top-xs list-item"
    >
      <div class="grid-x">
        <div class="cell small-6 heavy">
          {{ name }}
        </div>
        <div class="cell small-6 text-right">
          {{ distance }}
        </div>
      </div>
      <div class="heavy">
        {{ address }}
      </div>
      <div
        v-if="useFccApi && bossAvailabilityMessage && showAvailability"
        class="padding-top-xs"
      >
        Available in <span class="medium">{{ bossAvailabilityMessage }}</span>
      </div>
      <div class="padding-top-xs">
        <div v-if="today || tomorrow">
          Store Hours
        </div>
        <div v-if="today">
          Today: {{ today.toUpperCase() }}
        </div>
        <div v-if="tomorrow">
          Tomorrow: {{ tomorrow.toUpperCase() }}
        </div>
      </div>
      <div
        v-if="myStoreButton"
        class="grid-x padding-top-xs"
      >
        <button
          :class="[locationNumber === myStoreId ? 'disabled' : '']"
          :disabled="locationNumber === myStoreId"
          class="button secondary cell small-12 large-5 margin-bottom-s"
          :aria-label="
            locationNumber === myStoreId
              ? name + 'store currently selected'
              : `Set ${name} As My Store`
          "

          @click="locationNumber !== myStoreId ? setSelectedStore({ locationNumber, storeNumber, productId, name,
                                                                    address, localStorageModel, bopsAvailability, bossAvailability,
                                                                    pickupRelativeDay, bossAvailabilityMessage } ) : '' "
        >
          {{ locationNumber == myStoreId ? "My Store" : "Set As My Store" }}
        </button>
      </div>
      <div
        v-if="showAccordion && useFccApi"
        class="accordions"
      >
        <Accordion
          :multiple="true"
          lazy
        >
          <AccordionTab
            v-if="pickupItemInfo.bops.itemCount"
            :header="`${pickupItemInfo.bops.itemCount}
                      ${
              pickupItemInfo.bops.itemCount > 1 ? 'ITEMS' : 'ITEM'
            } AVAILABLE ${pickupRelativeDay}`"
            :header-style="accordionHeaderStyle"
            :content-style="accordionContentStyle"
          >
            <ul
              v-for="({ productName, productColors, productSizes }, index) in pickupItemInfo.bops
                .items"
              :key="index"
              class="padding-left-xs"
            >
              <li>
                <p v-if="productName">
                  {{ productName }}
                </p>
                <p class="margin-top-xxs margin-bottom-xxs">
                  <span v-if="productName"> Color: {{ productColors[0] }}</span> <span v-if="productSizes"> Size: {{ productSizes }} </span>
                </p>
              </li>
            </ul>
          </AccordionTab>
          <AccordionTab
            v-if="pickupItemInfo.boss.itemCount"
            :header="`${pickupItemInfo.boss.itemCount}
                      ${
              pickupItemInfo.boss.itemCount > 1 ? 'ITEMS' : 'ITEM'
            } AVAILABLE IN ${bossAvailabilityMessage}`"
            :header-style="accordionHeaderStyle"
            :content-style="accordionContentStyle"
          >
            <ul
              v-for="({ productName, productColors, productSizes }, index) in pickupItemInfo.boss
                .items"
              :key="index"
              class="padding-left-xs"
            >
              <li>
                <p v-if="productName">
                  {{ productName }}
                </p>
                <p class="margin-top-xxs margin-bottom-xxs">
                  <span v-if="productName"> Color: {{ productColors[0] }}</span> <span v-if="productSizes"> Size: {{ productSizes }} </span>
                </p>
              </li>
            </ul>
          </AccordionTab>
        </Accordion>
      </div>
    </div>
    <div
      v-if="unavailableStores.length"
      class="margin-top-xs"
    >
      <p class="margin-bottom-xs">
        <b>Your items are not available at:</b>
      </p>
      <div
        v-for="(storeName, index) in unavailableStores"
        :key="index"
      >
        <p>{{ storeName }}</p>
      </div>
    </div>
  </div>

  <div
    v-else-if="searchByZipCode"
    class="grid-x list-wrapper"
  >
    <div
      v-if="stores.enteredZipCode"
      role="status"
      class="margin-top-xs"
    >
      {{
        `${stores.length} stores within ${locationRadius} miles of ${stores.enteredZipCode}`
      }}
    </div>
    <div
      v-for="(
        {
          locationNumber,
          storeNumber,
          name,
          distance,
          address,
          today,
          tomorrow,
          curbsideToday,
          curbsideTomorrow,
          localStorageModel,
        },
        index
      ) in stores"
      :key="index"
      class="cell small-12 padding-top-xs padding-right-xxs list-item"
    >
      <div class="grid-x">
        <div class="cell small-6 heavy">
          {{ name }}
        </div>
        <div class="cell small-6 text-right">
          {{ distance }}
        </div>
      </div>
      <div class="heavy">
        {{ address }}
      </div>
      <div class="padding-top-xs">
        <div v-if="today || tomorrow">
          Store Hours
        </div>
        <div v-if="today">
          Today: {{ today }}
        </div>
        <div v-if="tomorrow">
          Tomorrow: {{ tomorrow }}
        </div>
        <div
          v-if="showCurbsideHours"
          class="padding-top-xs"
        >
          <div v-if="curbsideToday || curbsideTomorrow">
            Curbside Hours
          </div>
          <div v-if="curbsideToday">
            Today: {{ curbsideToday }}
          </div>
          <div v-if="curbsideTomorrow">
            Tomorrow: {{ curbsideTomorrow }}
          </div>
        </div>
      </div>
      <div class="grid-x padding-top-xs">
        <button
          v-if="searchByZipCode"
          :class="[locationNumber === myStoreId ? 'disabled' : '']"
          :disabled="locationNumber === myStoreId"
          class="button secondary cell small-12 large-5 margin-bottom-s"
          :aria-label="
            locationNumber === myStoreId
              ? name + 'store currently selected'
              : `Set ${name} As My Store`
          "
          @click="locationNumber !== myStoreId ? setSelectedStore({ locationNumber, storeNumber, name, address, localStorageModel } ) : '' "
        >
          {{ locationNumber == myStoreId ? "My Store" : "Set As My Store" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Cookie } from '@vue-util/cookie';
import { Accordion, AccordionTab } from '@atomic-ui/accordion';
import { fireTag } from '@vue-util/tagManager';
import { SET_STORE } from '../types/actions';
import * as globalStoreChange from '../utils/globalStoreChange';

export default {
  name: 'Stores',
  components: {
    Accordion,
    AccordionTab,
  },
  props: {
    myStoreId: {
      type: Number,
      default: null,
    },
    bagItems: {
      type: Array,
      default: () => [],
    },
    myStoreButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      accordionHeaderStyle: { fontWeight: 500, fontSize: '14px', 'text-transform': 'uppercase' },
      accordionContentStyle: { fontWeight: 400, fontSize: '14px' },
    };
  },
  computed: {
    ...mapState('locations', [
      'stores',
      'AccordionData',
      'unavailableStores',
      'searchByZipCode',
      'locationRadius',
      'useFccApi',
      'showAccordion',
      'showCurbsideHours',
      'showAvailability',
      'page',
    ]),
  },
  methods: {
    ...mapActions('locations', [SET_STORE]),
    setSelectedStore(store) {
      Cookie.set('CSL', store.locationNumber);
      const is365Customer = (Cookie.get('Login365Customer', 'MISCGCs') === 'Y');
      const expiryExtension = is365Customer ? 31556952000 : 2592000000;

      Cookie.set('BOPSPICKUPSTORE', store.locationNumber, 'MISCGCs', {
        expires: new Date(new Date().getTime() + expiryExtension),
      });

      const latLong = String(`${store.localStorageModel.geoLocation.latitude},${store.localStorageModel.geoLocation.longitude}`);

      Cookie.set('USERLL', latLong, 'MISCGCs', {
        expires: new Date(new Date().getTime() + expiryExtension),
      });

      const { zipCode } = store.localStorageModel.address;

      Cookie.set('USERPC', zipCode.substring(0, 5), 'MISCGCs', {
        expires: new Date(new Date().getTime() + expiryExtension),
      });

      const { state } = store.localStorageModel.address;
      Cookie.set('USERST', state, 'MISCGCs', {
        expires: new Date(new Date().getTime() + expiryExtension),
      });

      Cookie.set('PDDST', state, 'MISCGCs', {
        expires: new Date(new Date().getTime() + expiryExtension),
      });

      this.fireTagForStoreSelection(store);

      this.updateLocalStorage(store.localStorageModel);
      globalStoreChange.dispatchPageStoreChange();
      this[SET_STORE](store);
    },
    updateLocalStorage(data) {
      window.localStorage.removeItem('commonstorelocation');
      window.localStorage.setItem('commonstorelocation', JSON.stringify(data));
    },

    fireTagForStoreSelection(store) {
      const zipCode = store.localStorageModel.address.zipCode || '';
      let bopsLinkMessage = '';
      if (this.page === 'pdp' || this.page === 'bag') {
        if (store?.bopsAvailability?.toUpperCase() === 'AVAILABLE') {
          bopsLinkMessage = store.pickupRelativeDay.toUpperCase();
        } else if (store?.bossAvailability?.toUpperCase() === 'AVAILABLE') {
          bopsLinkMessage = store.bossAvailabilityMessage.toUpperCase();
        } else {
          bopsLinkMessage = 'NA';
        }
        const bopsLinkTagMessage = [`In Store:${bopsLinkMessage}-Curbside:NA`];
        const updatedStoreTags = {
          action_location: this.page === 'bag' ? `${this.page}-body`.toUpperCase() : `${this.page}-body`,
          postalCode: zipCode,
          site_action: 'store change complete',
          event_name: this.page === 'pdp' ? 'select pickup store' : 'bag search store complete',
          product_id: [store.productId],
        };
        if (this.page === 'pdp') {
          updatedStoreTags.search_store_id = store.locationNumber;
          updatedStoreTags.action_misc = this.myStoreId;
          updatedStoreTags.customer_store_id = store.locationNumber;
          updatedStoreTags.search_store_keyword = zipCode;
          updatedStoreTags.delivery_type = 'own';
          updatedStoreTags.pickup_eligibility = bopsLinkTagMessage;
        } else {
          updatedStoreTags.action_misc = store.locationNumber;
        }
        fireTag('link', updatedStoreTags);
      } else if (this.page === 'plp' || this.page === 'browse') {
        fireTag('link', {
          action_location: 'left nav',
          action_misc: store.locationNumber,
          postalCode: zipCode,
          site_action: 'store change complete',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-wrapper {
  max-height: calc(100% - 10.5rem);
  .list-item {
    border-bottom: $gray-3-border;
  }
  .accordions {
    border-top: $gray-3-border;
  }
}

</style>
